import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../app.state'; // Root AppState
import { errorReducer } from 'src/app/shared/error/store/reducers/error.reducer'; // Error Reducer
import { userReducer } from 'src/app/auth/store/user/user.reducer';

export const appReducers: ActionReducerMap<AppState> = {
  error: errorReducer, // Add other reducers here as necessary
  user: userReducer,
};
